export default __webpack_public_path__ + "static/9-4--24a062b824e61a309c83069f9107f878.png";